import { TableUIProvider } from "../../contexts/TableUIContext";
import Users from "./Users";

export default function UsersWrapper() {
    return (
        <TableUIProvider>
            <Users />
        </TableUIProvider>
    );
}
